import { IChallengeItem } from './fetch-service';
import Title from '../components/text/Title';
import HorizontalLine from '../components/decorations/lines/HorizontalLine';
import Subtitle from '../components/text/Subtitle';
import SmallText from '../components/text/SmallText';
import FormGroup from '../components/inputs/FormGroup';
import Select from '../components/inputs/Select';
import Input from '../components/inputs/Input';
import List from '../components/list/List';
import ListItem from '../components/list/ListItem';
import CloseButton from '../components/buttons/CloseButton';
import React from 'react';
import Button from '../components/buttons/Button';
import Link from '../components/text/Link';
import { toAbsoluteUrl } from './AssetHelpers';
import { PRIMARY_COLOR } from '../components/constants/style-constants';
import { useCommon } from '../store/CommonContext';
import Checkbox from '../components/inputs/Checkbox';
import RadioButton from '../components/inputs/RadioButton';
import LottieIcon from '../components/animation/LottieIcon';
import Image from '../components/image/Image';
import RadioListItem from '../components/list/RadioListItem';
import Loader from '../components/loader/Loader';

interface ITemplateBuilderProps {
  template: IChallengeItem[] | null;
  isFormGroup?: boolean;
  values: any;
  formik: any;
  spreedlyFormik: any;
  isCard?: boolean;
  isButtonDisabled: boolean;
  inputChangeCallback?: () => void;
}

export const TemplateBuilder = (props: ITemplateBuilderProps) => {
  const { template, isFormGroup, values, formik, spreedlyFormik, isCard, isButtonDisabled, inputChangeCallback } =
    props;

  const {
    state: { configuration },
  } = useCommon();

  if (template === null) return <></>;

  const builder = (el: IChallengeItem, index: number) => {
    const attributes = el.attributes || {};
    const children =
      el?.children && el?.children?.length > 0 ? (
        <TemplateBuilder
          template={el.children}
          values={values}
          formik={formik}
          spreedlyFormik={spreedlyFormik}
          isFormGroup={isFormGroup}
          isCard={isCard}
          isButtonDisabled={isButtonDisabled}
          inputChangeCallback={inputChangeCallback}
        />
      ) : null;

    switch (el.component?.toLowerCase()) {
      /* tslint:disable */
      case 'spacer':
        return <div className={`ui-widget-spacer ui-widget-spacer-${el?.properties?.Count} `} />;
      case 'div':
        const additionalStyles: { [key: string]: string } = {};

        if (
          el?.classes?.includes('ui-widget-dialog') &&
          (!!configuration?.modalCornersRadius ||
            configuration?.modalCornersRadius === 0 ||
            configuration?.modalCornersRadius === '0')
        ) {
          additionalStyles['borderRadius'] = configuration?.modalCornersRadius as string;
        }
        return (
          <div
            className={el?.classes?.join(' ')}
            {...attributes}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            /* @ts-ignore */
            dataid={el.dataId}
            style={{
              ...(typeof configuration?.primaryColor === 'string' && { color: configuration.primaryColor }),
              ...additionalStyles,
            }}
          >
            {el?.text || children}
          </div>
        );

      case 'radiolistitem':
        return (
          <RadioListItem
            {...attributes}
            // classes={el?.classes}
            id={el.dataId}
            imageUrl={el?.properties?.imageUrl}
            imageBase64={el?.properties?.imageBase64}
            imageName={el?.properties?.imageName}
            formik={formik}
            text={el?.text || ''}
            name={el.attributes?.name || ''}
            value={formik?.values?.[el.dataId || ''] || ''}
            children={children}
          />
        );

      case 'image':
      case 'img':
        // if (!el?.attributes?.src) return null;

        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          /* @ts-ignore */
          <Image
            {...attributes}
            classes={el?.classes}
            dataId={el.dataId}
            imageUrl={el?.properties?.imageUrl}
            imageBase64={el?.properties?.imageBase64}
            imageName={el?.properties?.imageName}
            fontAwesomeIcon={el?.properties?.fontAwesomeIcon}
          />
        );
      case 'lottie':
      case 'lottieanimation':
        return (
          <LottieIcon
            additionalClasses={el?.classes?.join(' ')}
            animationName={el?.properties?.animationName}
            width={el?.properties?.width}
            height={el?.properties?.height}
            loop={el?.properties?.loop}
            autoplay={el?.properties?.autoplay}
          />
        );

      case 'text':
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          /* @ts-ignore */
          <div className={'ui-widget-text ' + el?.classes?.join(' ')} {...attributes} dataid={el.dataId}>
            {el?.text || children}
          </div>
        );
      case 'span':
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          /* @ts-ignore */
          <span className={el?.classes?.join(' ')} {...attributes} dataid={el.dataId}>
            {el?.text || children}
          </span>
        );
      case 'bold':
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          /* @ts-ignore */
          <b className={el?.classes?.join(' ')} {...attributes} dataid={el.dataId}>
            {el?.text || children}
          </b>
        );
      case 'center':
        return (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          /* @ts-ignore */
          <div className={`ui-widget-text-center  ${el?.classes?.join(' ')}`} {...attributes} dataid={el.dataId}>
            {el?.text || children}
          </div>
        );
      case 'button':
        return (
          <Button
            additionalClasses={el?.classes?.join(' ')}
            text={el?.text || ''}
            dataid={el.dataId}
            attributes={attributes}
            disabled={isButtonDisabled}
            imageUrl={el?.properties?.imageUrl}
            imageBase64={el?.properties?.imageBase64}
            imageName={el?.properties?.imageName}
            backgroundColor={el?.properties?.backgroundColor}
            fontAwesomeIcon={el?.properties?.fontAwesomeIcon}
            color={el?.properties?.color}
            iconColor={el?.properties?.iconColor}
            href={attributes?.href}
            target={attributes?.target || '_self'}
          />
        );
      case 'link':
        return (
          <Link
            additionalClasses={el?.classes?.join(' ')}
            dataid={el.dataId}
            href={attributes?.href || ''}
            attributes={attributes}
          >
            {el?.text || children}
          </Link>
        );
      case 'br':
      case 'break':
        return <br />;

      case 'closebutton':
        return <CloseButton dataid={el.dataId} />;
      case 'list':
        return <List additionalClasses={el?.classes?.join(' ')}>{children}</List>;
      case 'listitem':
        return <ListItem additionalClasses={el?.classes?.join(' ')}>{el?.text || children}</ListItem>;
      case 'title':
        return children ? (
          <Title text={el.text || ''} additionalClasses={el?.classes?.join(' ')}>
            {children}
          </Title>
        ) : (
          <Title text={el.text || ''} additionalClasses={el?.classes?.join(' ')} />
        );
      case 'separatorhorizontal':
        return <HorizontalLine additionalClasses={el?.classes?.join(' ')} />;
      case 'subtitle':
        return children ? (
          <Subtitle additionalClasses={el?.classes?.join(' ')} text={el.text || ''}>
            {children}
          </Subtitle>
        ) : (
          <Subtitle additionalClasses={el?.classes?.join(' ')} text={el.text || ''} />
        );
      case 'smalltext':
        return children ? (
          <SmallText additionalClasses={el?.classes?.join(' ')} text={el.text || ''}>
            {children}
          </SmallText>
        ) : (
          <SmallText additionalClasses={el?.classes?.join(' ')} text={el.text || ''} />
        );
      case 'formgroup':
        return (
          <FormGroup formik={formik}>
            <TemplateBuilder
              template={el.children}
              values={values}
              formik={formik}
              spreedlyFormik={spreedlyFormik}
              isFormGroup={true}
              isCard={isCard}
              isButtonDisabled={isButtonDisabled}
              inputChangeCallback={inputChangeCallback}
            />
          </FormGroup>
        );
      case 'input':
      case 'smallinput':
      case 'extrasmallinput':
      case 'mediuminput':
        if (el.inputType === 'Select') {
          return (
            <Select
              additionalClasses={el?.classes?.join(' ')}
              potentialAnswers={[
                { id: '', text: el.placeholder || '', description: '', order: 0 },
                ...el.potentialAnswers,
              ]}
              isSmall={el.component === 'SmallInput'}
              isNextSmall={template?.[index + 1]?.component === 'SmallInput'}
              isFormGroup={!!isFormGroup}
              name={isCard && el.attributes?.name ? el.attributes?.name : (el.dataId as string)}
              placeholder={el.placeholder || el.text}
              formik={formik}
              inputChangeCallback={inputChangeCallback}
            />
          );
        }
        // else if (el.inputType === 'CreditCard') {
        //   return <SpreedlyWrapper formik={spreedlyFormik} isCard={el.inputType === 'CreditCard'} />;
        // }
        else if (
          el.inputType === 'OpenBanking_Plaid' ||
          el.inputType === 'Spreedly_3DS' ||
          el.inputType === 'Tokenex_3DS'
        ) {
          return null;
        } else {
          return (
            <Input
              additionalClasses={el?.classes?.join(' ')}
              inputType={el.inputType === 'Number' ? 'number' : 'text'}
              isSmall={el.component === 'SmallInput'}
              isNextSmall={template?.[index + 1]?.component === 'SmallInput'}
              isFormGroup={!!isFormGroup}
              name={isCard && el.attributes?.name ? el.attributes?.name : (el.dataId as string)}
              placeholder={el.placeholder || el.text}
              formik={formik}
              attributes={attributes}
              inputChangeCallback={inputChangeCallback}
            />
          );
        }

      case 'checkbox':
        return (
          <Checkbox
            additionalClasses={el?.classes?.join(' ')}
            label={el.text || ''}
            id={el?.dataId || ''}
            formik={formik}
          />
        );

      case 'radiobutton':
        return (
          <RadioButton
            additionalClasses={el?.classes?.join(' ')}
            label={el.text || ''}
            name={el.attributes?.name || ''}
            id={el.dataId || ''}
            formik={formik}
            value={formik?.values?.[el.dataId || ''] || ''}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      {template?.map((el, index) => {
        return <React.Fragment key={`challenge-${el.uniqueId}`}>{builder(el, index)}</React.Fragment>;
      })}
    </>
  );
};
